<template>
  <div class="videoresume-stup-modal-wrapper">
    <div class="videoresume-stup-modal">
      <div class="videoresume-stup-title">{{$tr('videoresume.stup.title')}}</div>
      <div class="videoresume-stup-text" v-html="$tr('videoresume.stup.text1', {link: videoresumeLink})"></div>
      <div class="videoresume-stup-text" v-html="$tr('videoresume.stup.text2', {link: vcvLink})"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoresumeStup',

  props: ['response'],

  computed: {
    vcvLink() {
      const host = window.location.hostname;
      const hostArray = host.split('.');
      const domain = `${hostArray.slice(hostArray.length - 1)}`;
      if (domain === 'ru') {
        return 'https://vcv.ru';
      } else {
        return 'https://vcv.ai';
      }
    },

    videoresumeLink() {
      if (!this.response || !this.response.vacancy) {
        return this.vcvLink;
      }

      return `/r/${this.response.vacancy.token}`;
    }
  },
}
</script>

<style lang="scss" scoped>
  .videoresume-stup-modal-wrapper {
    background: #c0b3e6;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .videoresume-stup-modal {
    background: #fff;
    box-shadow: 0px 0px 25px rgba(35, 51, 70, 0.05);
    border-radius: 2px;
    padding: 2.5rem 1rem;
  }

  .videoresume-stup-title {
    margin-bottom: 18px;
    // font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 36px;
    text-align: center;
    color: #555555;
  }

  .videoresume-stup-text {
    color: #8D8D8D;
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    transition: color .35s ease;

    ::v-deep a {
      color: #8D8D8D;
      text-decoration: underline;

      &:hover,
      &:focus,
      &:active {
        color: #8D8D8D;
        text-decoration: underline;
      }
    }
  }
  
</style>